import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from 'core/services/http-data.service';

@Injectable()
export class SsoConfigurationsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/core/clients');
  }

  getFetchUrl() {
    const fetchUrl = `${this.apiUrl}/auth/sso/config`;
    return fetchUrl;
  }

  fetchClientSsoConfigurations(clientId) {
    return this.fetch({ clientId }).then((data) => data.docs || []);
  }

  updateSsoConfig(clientId: string, ssoConfig: any): Promise<any> {
    const url = `${this.baseUrl}/${clientId}/sso`;
    return super.putRequest(url, ssoConfig, this.getRequestOptions());
  }
}
